// extracted by mini-css-extract-plugin
export default {"title":"I_lSJ","buttonWrapper":"vR1_R","button":"arYM4","collapse":"CT6z6","isOpen":"qDxDq","container":"ZhKYk ZdH1P"};